import React from 'react';
import {Navigate, Outlet, Route, Routes} from 'react-router-dom';
import {useAuth} from './hooks/useAuth';

// Layouts
import MainLayout from './components/layout/MainLayout';
import AuthLayout from './components/layout/AuthLayout';

// Pages publiques
import Home from './pages/Home';
import Login from './pages/auth/Login';
import ResetPassword from './pages/auth/ResetPassword';

// Pages privées (pour tous les utilisateurs authentifiés)
import Dashboard from './pages/admin/Dashboard';
import Profile from './pages/profile/Profile';
import RecensementForm from "./pages/recensement/RecensementForm";
import Confirmation from "./pages/recensement/Confirmation";
import ChurchAdd from "./pages/churches/ChurchAdd";
import ChurchEdit from "./pages/churches/ChurchEdit";
import Churches from "./pages/churches/Churches";
import ChurchDetail from "./pages/churches/ChurchDetail";
import MembersList from './pages/members/MembersList';
import MemberDetail from "./pages/members/MemberDetail";
import MemberEdit from "./pages/members/MemberEdit";
import MemberAdd from "./pages/members/MemberAdd";
import UserManagement from "./pages/admin/UserManagement";
import ChurchesSummary from "./pages/churches/ChurchSummary";

// Pages pour les administrateurs d'église et admin généraux
/*
import MemberDetail from './pages/members/MemberDetail';
import MemberEdit from './pages/members/MemberEdit';
import MemberAdd from './pages/members/MemberAdd';

// Pages pour l'envoi de messages
import Messages from './pages/messages/Messages';
import NewMessage from './pages/messages/NewMessage';

// Pages admin uniquement
import Churches from './pages/churches/Churches';
import ChurchDetail from './pages/churches/ChurchDetail';
import ChurchEdit from './pages/churches/ChurchEdit';
import ChurchAdd from './pages/churches/ChurchAdd';
import UserManagement from './pages/admin/UserManagement';
*/

// Route protégée de base (utilisateur connecté)
const ProtectedRoute = () => {
    const {currentUser, loading} = useAuth();

    if (loading) {
        return (
            <div className="flex justify-center items-center h-screen">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
            </div>
        );
    }

    return currentUser ? <Outlet/> : <Navigate to="/login"/>;
};

// Route protégée pour administrateurs d'église et admins globaux
const AdminRoute = () => {
    const {userRole, loading} = useAuth();

    if (loading) {
        return (
            <div className="flex justify-center items-center h-screen">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
            </div>
        );
    }

    return userRole && (userRole.role === 'admin' || userRole.role === 'church_admin') ?
        <Outlet/> : <Navigate to="/dashboard"/>;
};

// Route protégée uniquement pour les administrateurs globaux
const SuperAdminRoute = () => {
    const {userRole, loading} = useAuth();

    if (loading) {
        return (
            <div className="flex justify-center items-center h-screen">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
            </div>
        );
    }

    return userRole && userRole.role === 'admin' ?
        <Outlet/> : <Navigate to="/dashboard"/>;
};

// Configuration des routes
const AppRoutes = () => {
    return (
        <Routes>
            {/* Routes publiques */}
            <Route path="/" element={<Home/>}/>
            <Route path="/recensement" element={<RecensementForm/>}/>
            <Route path="/recensement/confirmation" element={<Confirmation/>}/>

            {/* Routes d'authentification */}
            <Route element={<AuthLayout/>}>
                <Route path="/login" element={<Login/>}/>
                <Route path="/reset-password" element={<ResetPassword/>}/>
            </Route>

            {/* Routes protégées (utilisateurs connectés) */}
            <Route element={<ProtectedRoute/>}>
                <Route element={<MainLayout/>}>
                    <Route path="/dashboard" element={<Dashboard/>}/>
                    <Route path="/profile" element={<Profile/>}/>

                    {/* Routes pour administrateurs d'église et admins globaux */}
                    <Route element={<AdminRoute/>}>
                        <Route path="/members" element={<MembersList/>}/>
                        <Route path="/members/add" element={<MemberAdd/>}/>
                        <Route path="/members/:id" element={<MemberDetail/>}/>
                        <Route path="/members/:id/edit" element={<MemberEdit/>}/>

                        {/*    <Route path="/messages" element={<Messages />} />*/}
                        {/*    <Route path="/messages/new" element={<NewMessage />} />*/}
                    </Route>

                    {/* Routes admin uniquement */}
                    <Route element={<SuperAdminRoute/>}>
                        <Route path="/churches" element={<Churches/>}/>
                        <Route path="/churches/:id" element={<ChurchDetail/>}/>
                        <Route path="/churches/:id/edit" element={<ChurchEdit/>}/>
                        <Route path="/churches/add" element={<ChurchAdd/>}/>
                        <Route path="/admin/users" element={<UserManagement/>}/>
                        <Route path="/churches/summary" element={<ChurchesSummary />} />
                    </Route>
                </Route>
            </Route>

            {/* Route par défaut - redirection vers l'accueil */}
            <Route path="*" element={<Navigate to="/"/>}/>

        </Routes>
    );
};

export default AppRoutes;
